/**
 * The one line that says you just gave yourself away.
 *
 * Only ever shown for your own taunt, which is not a display choice but the
 * protocol's: `Msg.Taunt` carries no player id, so there is nothing this could
 * say about anybody else even if it wanted to. Somebody else's taunt is a
 * sound, and a sound is the entire information — narrating it in text would
 * hand a hunter a reliable, latency-free "a hider is nearby" that their ears
 * are supposed to have to earn.
 *
 * A taunt is involuntary, so the player it happened to has to know it happened:
 * they hear it centred on themselves, where it is indistinguishable from
 * somebody standing next to them, and a muted client would otherwise have its
 * position published with no signal at all.
 */

import type { TauntMsg } from "@prop-hunt/shared";

/** Long enough to read while running, short enough not to outlive the sound. */
const MESSAGE_HOLD_MS = 1600;

export class TauntHud {
  private readonly el: HTMLElement;
  /** Identity of the taunt already shown; see `TagHud.onTag`. */
  private shown: TauntMsg | null = null;
  private until = 0;

  constructor(root: HTMLElement) {
    this.el = document.createElement("div");
    this.el.className = "taunt-message";
    this.el.textContent = "YOU TAUNTED";
    this.el.hidden = true;
    root.appendChild(this.el);
  }

  onTaunt(taunt: TauntMsg | null, now: number): void {
    if (taunt === null || taunt === this.shown) return;
    this.shown = taunt;
    if (!taunt.self) return;
    this.until = now + MESSAGE_HOLD_MS;
  }

  update(now: number): void {
    this.el.hidden = now > this.until;
  }
}
